import { AnimatedEvent, attachNativeEvent } from "./AnimatedEvent";
import AnimatedImplementation from "./AnimatedImplementation";
import createAnimatedComponent from "./createAnimatedComponent";
import AnimatedColor from "./nodes/AnimatedColor";
import AnimatedInterpolation from "./nodes/AnimatedInterpolation";
import AnimatedNode from "./nodes/AnimatedNode";
import AnimatedValue from "./nodes/AnimatedValue";
import AnimatedValueXY from "./nodes/AnimatedValueXY";
var inAnimationCallback = false;
function mockAnimationStart(start) {
  return (callback) => {
    var guardedCallback = callback == null ? callback : function() {
      if (inAnimationCallback) {
        console.warn(
          "Ignoring recursive animation callback when running mock animations"
        );
        return;
      }
      inAnimationCallback = true;
      try {
        callback(...arguments);
      } finally {
        inAnimationCallback = false;
      }
    };
    start(guardedCallback);
  };
}
var emptyAnimation = {
  start: () => {
  },
  stop: () => {
  },
  reset: () => {
  },
  _startNativeLoop: () => {
  },
  _isUsingNativeDriver: () => {
    return false;
  }
};
var mockCompositeAnimation = (animations) => ({
  ...emptyAnimation,
  start: mockAnimationStart((callback) => {
    animations.forEach((animation) => animation.start());
    callback == null ? void 0 : callback({
      finished: true
    });
  })
});
var spring = function spring2(value, config) {
  var anyValue = value;
  return {
    ...emptyAnimation,
    start: mockAnimationStart((callback) => {
      anyValue.setValue(config.toValue);
      callback == null ? void 0 : callback({
        finished: true
      });
    })
  };
};
var timing = function timing2(value, config) {
  var anyValue = value;
  return {
    ...emptyAnimation,
    start: mockAnimationStart((callback) => {
      anyValue.setValue(config.toValue);
      callback == null ? void 0 : callback({
        finished: true
      });
    })
  };
};
var decay = function decay2(value, config) {
  return emptyAnimation;
};
var sequence = function sequence2(animations) {
  return mockCompositeAnimation(animations);
};
var parallel = function parallel2(animations, config) {
  return mockCompositeAnimation(animations);
};
var delay = function delay2(time) {
  return emptyAnimation;
};
var stagger = function stagger2(time, animations) {
  return mockCompositeAnimation(animations);
};
var loop = function loop2(animation, _temp) {
  var _ref = _temp === void 0 ? {} : _temp, _ref$iterations = _ref.iterations, iterations = _ref$iterations === void 0 ? -1 : _ref$iterations;
  return emptyAnimation;
};
var AnimatedMock_default = {
  Value: AnimatedValue,
  ValueXY: AnimatedValueXY,
  Color: AnimatedColor,
  Interpolation: AnimatedInterpolation,
  Node: AnimatedNode,
  decay,
  timing,
  spring,
  add: AnimatedImplementation.add,
  subtract: AnimatedImplementation.subtract,
  divide: AnimatedImplementation.divide,
  multiply: AnimatedImplementation.multiply,
  modulo: AnimatedImplementation.modulo,
  diffClamp: AnimatedImplementation.diffClamp,
  delay,
  sequence,
  parallel,
  stagger,
  loop,
  event: AnimatedImplementation.event,
  createAnimatedComponent,
  attachNativeEvent,
  forkEvent: AnimatedImplementation.forkEvent,
  unforkEvent: AnimatedImplementation.unforkEvent,
  Event: AnimatedEvent
};
export {
  AnimatedMock_default as default
};
//# sourceMappingURL=AnimatedMock.js.map
